const items = [
  'Social Media Management',
  'Voiceovers',
  'Photography & Videography',
  'Video Editing',
  'Graphic Design',
  'Promotion Strategy',
  'Email Marketing',
  'SEO',
  'Web Development',
];

const Marquee = () => {
  const repeated = [...items, ...items, ...items];
  return (
    <div className="marquee-wrap">
      <div className="marquee-track">
        {repeated.map((item, i) => (
          <span className="marquee-item" key={i}>
            {item}
            <svg className="marquee-dot" viewBox="0 0 6 6" fill="currentColor" width="6" height="6">
              <circle cx="3" cy="3" r="3" />
            </svg>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
